"use strict";

import angular from "angular";

function cnpjExistsDirective() {
    return {
        restrict: "A",
        require: "?ngModel",
        link: function (scope, element, attrs, ctrl) {
            element.on("change", function () {
                scope.$apply(function () {
                    ctrl.$setValidity("cnpjExists", true);
                });
            });
        }
    };
}

const name = "cnpjExists";
const factory = cnpjExistsDirective;
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
